import { Link } from "@inertiajs/react"

export function MobileActionBar() {
    return (
        <div className="bg-[#820003] sticky top-20 z-[99] justify-center w-full block lg:hidden">
            <div className="container flex justify-between px-6 py-2 text-sm text-white lg:justify-around lg:text-lg">
                <Link href="/auctions" className="font-bold uppercase">
                    Buy
                </Link>
                <Link href="/sell-my-gun" className="font-bold uppercase">
                    Sell
                </Link>
                <Link
                    href="/gun-consignment"
                    className="font-bold uppercase"
                >
                    Consign
                </Link>
            </div>
        </div>
    )
}
